import { type TimestampModel } from '../../types';
import { type OperationViewModel } from '../Map/types';

export enum TripsAndJobsSearchResultType {
  Trip = 'Trip',
  Job = 'Job',
  Operation = 'Operation',
}

export interface TripSearchResultViewModel {
  id: string;
  vesselName: string;
  mmsi: number;
  assistedVesselName: string;
  assistedVesselMmsi: number;
  operation: string;
  timestamp: TimestampModel;
  resultType: TripsAndJobsSearchResultType;
}

export interface VesselSearchResultViewModel {
  mmsi: string;
  name: string;
  operation: string;
  timestamp: TimestampModel;
}

export interface SearchResultsManager {
  hasAnyResults: boolean;
  canSearch: boolean;
  isJobsAndTripsLoading: boolean;
  isVesselsLoading: boolean;
  isOperationsLoading: boolean;
  vesselResults: VesselSearchResultViewModel[];
  operationResults: OperationViewModel[];
  jobsAndTripsResults: TripSearchResultViewModel[];
}

export enum SearchContext {
  Global = 'Global',
  Operation = 'Operation',
  Vessel = 'Vessel',
}

export interface SearchResults<T> {
  data: T[];
  isLoading: boolean;
}
